import React from "react";
import "./../styles/globals/global.scss";

function LogosContainer({ mins, setMins, setOtherMins }) {
  return (
    <div
      className="logosContainer"
      style={{ textAlign: "center", marginBottom: "40px" }}
    >
      <div
        className="is-flex"
        style={{ justifyContent: "center", alignItems: "end" }}
      >
        <img
          style={{ width: "130px" }}
          src="/images/logo-powered-by.png"
          alt="Logo"
        />
        <div className="vertical-line"></div>
        <div className="flex" style={{ display: 'flex', alignItems: "center" }}>
          <img
            className="mr-3"
            style={{ width: "86px" }}
            src="/images/regulator.png"
            alt="Logo"
          />
          <img style={{ width: "14px" }} src="/images/bcorp.png" alt="Logo" />
        </div>
      </div>
    </div>
  );
}

export default LogosContainer;
